import type { ReactNode, ForwardedRef } from "react";
import React from "react";
import TabBar, { type Props as TabBarProps } from "../../DesignSystem/TabBar";
import { twMerge } from "tailwind-merge";

export interface RoundedContainerProps {
    children?: ReactNode;
    className?: string;
    tabs?: TabBarProps["tabs"];
    actions?: ReactNode;
    tabsContainerClassName?: string;
    contentContainerClassName?: string;
}

const RoundedContainer = React.forwardRef<HTMLDivElement, RoundedContainerProps>(
    ({ children, className, tabs, actions, tabsContainerClassName, contentContainerClassName }, ref) => {
        const tabsContainerClasses = twMerge("flex items-stretch border-b border-stone-200 p-3 md:items-center", tabsContainerClassName);
        const contentContainerClasses = twMerge(
            "custom-scrollbar w-full md:overflow-y-auto",
            tabs && tabs.length > 0 ? "h-[calc(100%-58px-1px)]" : "h-full",
            contentContainerClassName,
        );
        return (
            <section
                id="roundedContainer"
                className={`min-h-[calc(100dvh-48px)] rounded-t-2xl bg-white sm:h-[calc(100vh-56px-12px)] sm:min-h-[calc(100vh-56px-12px)] sm:overflow-x-hidden sm:rounded-2xl ${className}`}
            >
                {tabs && tabs.length > 0 && (
                    <div className={tabsContainerClasses}>
                        <TabBar tabs={tabs} id="rounded-container-tabs" />
                        {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
                    </div>
                )}
                <div ref={ref} className={contentContainerClasses}>
                    {children}
                </div>
            </section>
        );
    },
);

export default RoundedContainer;
